import { Component } from 'vue-property-decorator';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import DisciplineTable from '@centers/components/tables/discipline-table/discipline-table.vue';
import Vue from 'vue';

library.add(faSync);

@Component({
  name: 'bpc-discipline',
  components: {
    'bpc-discipline-table': DisciplineTable,
  },
})
export default class Disciplines extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
